import { InjectionKey } from 'vue';
import { createStore, useStore as baseUseStore, Store } from 'vuex';
import { IState } from '@store/IState';

import loader from './plugins/loader';

const debug = process.env.NODE_ENV !== 'production';
// eslint-disable-next-line symbol-description
export const storeKey: InjectionKey<Store<IState>> = Symbol();

export const store = createStore<IState>({
  actions: {},
  state: { results: {} },

  mutations: {
    setStore(state, result) {
      state.results = { ...state.results, [result.name]: result.value };
    },
    setStoreModule(state, { name, value }) {
      try {
        if (state[name]) {
          state[name].data = { ...state[name].data, ...value };
        }
      } catch (err) {
        console.error(err);
      }
    },
    'store/setResultsStore'(state, result) {
      state.results = { ...state.results, [result.name]: result.value };
    },
    'store/setStore'(state, { name, value }) {
      try {
        if (state[name]) {
          state[name].data = { ...state[name].data, ...value };
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
  getters: {
    'results/getCurrentLang'({ results: { siteLanguages } }): string | undefined {
      const langs = siteLanguages?.langs;
      if (!langs) return;

      // eslint-disable-next-line no-restricted-syntax
      for (const lang of Object.values(langs)) {
        // eslint-disable-next-line consistent-return
        if (lang.current) return lang.code;
      }
    },
    /**
     * get LANGUAGE_ID for request params
     * @param siteLanguages
     * @returns {{LANGUAGE_ID}}
     */
    getRequestLang: ({ results: { siteLanguages } }): { LANGUAGE_ID: string } | void => {
      if (!siteLanguages?.langs) return;
      const activeLanguage = Object.values(siteLanguages.langs).find((el) => el.current);
      if (activeLanguage?.code) {
        // eslint-disable-next-line consistent-return
        return { LANGUAGE_ID: activeLanguage.code };
      }
    },
    getCurrentLang: ({ results: { siteLanguages } }) => {
      if (!siteLanguages?.langs) return;
      // eslint-disable-next-line consistent-return
      return Object.values(siteLanguages.langs).find((el) => el.current);
    },

    isProd: ({ results: { siteLanguages } }) => siteLanguages?.isProd,
  },
  modules: {
    cabinet: require('./modules/cabinet').default,
    personal: require('./modules/personal').default,
    favourite: require('./modules/favourite').default,
    global: require('./modules/global/global').default,
    cities: require('./modules/cities').default,
    basket: require('./modules/basket').default,
    checkout: require('./modules/checkout').default,
    stores: require('./modules/stores').default,
    thanks: require('./modules/thanks').default,
    repair: require('./modules/repair').default,
    product: require('./modules/product').default,
    catalog: require('./modules/catalog').default,
    footerMiniBanner: require('./modules/footerMiniBanner').default,
    club: require('./modules/club').default,
  },
  plugins: [loader],
  strict: debug,
});

export function useStore() {
  return baseUseStore(storeKey);
}
